const FATIGUE_LEVELS = ['Fresh', 'Winded', 'Tired', 'Wearied', 'Exhausted', 'Debilitated']
const FATIGUE_ADJ_TYPES = ['SR', 'Move', 'Dex', 'Skill']

export default function isReadonlyFatigueAdj(adjReason) {
  if (!adjReason || typeof adjReason !== 'string') {
    return false
  }

  const trimmedReason = adjReason.trim()

  return FATIGUE_LEVELS.some((level) =>
    FATIGUE_ADJ_TYPES.some((adjType) => {
      const pattern = new RegExp(`^${level} ${adjType} Adj(?: \\([+-]?\\d+\\))?$`)
      return pattern.test(trimmedReason)
    }),
  )
}
